const experience = [
  {
    id: 1,
    company: "Canvendor",
    role: "Software Apprenticeship (Part-time)",
    location: "Chicago, IL (Remote)",
    startDate: "Jun 2025",
    endDate: "Aug 2025",
    current: false,
    highlights: [
      "Evaluated DevSecOps and observability tooling including SonarQube, Grafana, and OWASP ZAP across an existing codebase",
      "Produced documentation and implementation solutions for integrating security scanning and monitoring into CI/CD workflows"
    ]
  },
  {
    id: 2,
    company: "Lumiq (Crisp Analytics Pvt Ltd)",
    role: "Summer Intern",
    location: "Chennai, India",
    startDate: "Jun 2023",
    endDate: "Sep 2023",
    current: false,
    highlights: [
      "Built PySpark and Pandas data pipelines and SQL queries to process health insurance analytics data for fintech clients",
      "Automated recurring data processing tasks, reducing manual effort across the team",
      "Used the GreatExpectations library to run data quality checks across pipelines, ensuring clean and validated data at each stage of processing"
    ]
  }
];

export default experience;
